export default __webpack_public_path__ + "static/media/footer-logos.4217a712.png";